import { Grid } from "@material-ui/core";
import Dropdown from "../../../../../common/Dropdown";

const DestinationRouteList = ({
  destinationRouteName,
  onChange,
  errorInfo,
  classes,
  options=[],
}) => {
  return (
    <>
      <Grid item xs={4} className={classes.radioHeader}>
        Route Name
      </Grid>
      <Grid item xs={4} className={classes.folder}>
        <Dropdown
          autoFocus={false}
          value={destinationRouteName ?? null}
          options={options}
          onChange={onChange}
          isClearable={false}
        />
      </Grid>
      {errorInfo.destinationRouteName && (
        <div className={classes.errorColor}>
          {errorInfo.destinationRouteName}
        </div>
      )}
    </>
  );
};

export default DestinationRouteList;
